import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useGetUser = () => {
    const services = React.useContext(ServicesContext);

    const getUser = useCallback(
        async (id: number, options: ApiRequestOptionsType) => {
            try {
                const result = await services.api.call(
                    {
                        method: 'get',
                        url: `/api/users/${id}`,
                    },
                    options
                );

                return result.data;
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api]
    );

    return getUser;
};
